import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  CreateAuditorActions as Actions,
  CreateAuditorRequestAction as RequestAction,
} from 'store/ducks/auditors';

export function* createAuditorRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(postData);
    yield call(api.post, `auditors`, formData);
    onSuccess && onSuccess();
    notify('success', 'Fiscal criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
